"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MHFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_149)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_149`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#1E509C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 12.358V5.70532L-6 24.0001L30 12.358Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 0V5.70526L-6 24L30 0Z",
					fill: "#F18D36"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.89126 6.96837L2.3439 3.17188L1.80355 6.96837L0.343897 5.30521L1.09477 7.52275L-1.11575 6.77187L0.540388 8.23152L-3.2561 8.77188L0.540388 9.31223L-1.11575 10.7719L1.09477 10.021L0.343897 12.2385L1.80355 10.5754L2.3439 14.3719L2.89126 10.5754L4.3439 12.2385L3.60004 10.021L5.81056 10.7719L4.15442 9.31223L7.9439 8.77188L4.15442 8.23152L5.81056 6.77187L3.60004 7.52275L4.3439 5.30521L2.89126 6.96837Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_149`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MHFlag };
